// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ydJ6","right":"Footer_right__2DTzC","buttons":"Footer_buttons__1HQMA"};